import clsx from 'clsx';

import { Sponsor } from '@/entities/player-details/PlayerSponsors';

interface TeamInfoSponsorsListProps {
	sponsors: Sponsor[];
	className?: string;
}

export const TeamInfoSponsorsList = ({ sponsors, className }: TeamInfoSponsorsListProps) => {
	if (!sponsors || sponsors.length === 0) return null;

	return (
		<div className={clsx('hidden md:block', className)}>
			<h3 className="text-lg font-semibold mb-1">Player Sponsors</h3>

			<div className="flex gap-4 overflow-x-auto pb-2 bg-gray-200 rounded-lg p-2">
				{sponsors.map((sponsor) => {
					const primaryImage = sponsor.sponsorImages.find((img) => img.isPrimary) ?? sponsor.sponsorImages[0];

					if (!primaryImage) return null;

					return (
						<a
							key={sponsor.uuid}
							className={clsx('flex items-center justify-center bg-white rounded-md border w-28 h-20 flex-shrink-0 shadow-sm', {
								'cursor-default': !sponsor.url
							})}
							href={sponsor.url ?? '#'}
							target="_blank"
						>
							<img
								src={primaryImage.url}
								alt={primaryImage.uuid || 'Sponsor logo'}
								className="max-h-full max-w-full object-contain p-2"
							/>
						</a>
					);
				})}
			</div>
		</div>
	);
};
